import Client from './client';

export default class ExperimentMilestones extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, experimentKey, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments/${experimentKey}/milestone`, options);
  }

  post(organization, experimentKey, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments/${experimentKey}/milestone`, {
      ...options,
       method: 'POST',
    });
  }

  getById(organization, experimentKey, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments/${experimentKey}/milestone/${id}`, options);
  }

  putById(organization, experimentKey, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments/${experimentKey}/milestone/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteById(organization, experimentKey, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments/${experimentKey}/milestone/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
